import { render, staticRenderFns } from "./p-address.vue?vue&type=template&id=3f5ea6c3&"
import script from "./p-address.vue?vue&type=script&lang=js&"
export * from "./p-address.vue?vue&type=script&lang=js&"
import style0 from "./p-address.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports